export class Tabs {
  constructor(difference) {
    this.isDefaultComponent = true
    this.singleTabs = true
    this.styleId = 1
    this.width = 312 // 自适应也给个默认值，不然计算偏移值会有问题
    this.widthType = "自动"
    this.height = 34
    this.left = 0
    this.top = 0
    this.value = "Tab1"
    this.innerElement = "cxTabs"
    this.fontFamily = "sans-serif"
    this.hoverFontFamily = "sans-serif"
    this.fontSize = 16
    this.hoverFontSize = 16
    this.fontWeight = 400
    this.hoverFontWeight = 400
    this.color = "rgba(82,82,82,1)"
    this.textIsThemeColor = false
    this.hoverColor = "rgba(255,255,255,1)"
    this.hoverTextIsThemeColor = false
    this.bgColor = "#EDEDED"
    this.hoverBgColor = "#3D82F2"
    this.lineHeight = 34
    this.hoverLineHeight = 34
    this.letterSpacing = 0
    this.hoverLetterSpacing = 0
    this.fontStyle = "normal"
    this.hoverFontStyle = "normal"
    this.textAlign = "left"
    this.hoverTextAlign = "left"
    this.writingMode = "horizontal-tb"
    this.hoverWritingMode = "horizontal-tb"
    this.textDecoration = "none"
    this.hoverTextDecoration = "none"
    this.textIndent = 0
    this.hoverTextIndent = 0
    this.maxLength = 5
    this.hoverMaxTabLength = 10
    this.borderTopLeftRadius = 4
    this.borderTopRightRadius = 4
    this.borderBottomLeftRadius = 4
    this.borderBottomRightRadius = 4
    this.borderColor = "#000000"
    this.borderStyle = "solid"
    this.borderIsThemeColor = false
    this.hoverBorderColor = "#000000"
    this.hoverBorderStyle = "solid"
    this.hoverBorderWidth = 0
    this.hoverBorderIsThemeColor = false
    this.tabWidth = 98
    this.tabHeight = 34
    this.tabBackgroundColor = "#EDEDED"
    this.tabMarginRight = 40
    this.activeIndex = 0
    this.hoverUnderlineStyle = "solid"
    this.hoverUnderlineColor = "#fff"
    this.hoverUnderlineWidth = 1
    this.tabsList = [
      { name: "选项1", content: "选项1" },
      { name: "选项2", content: "选项2" },
      { name: "选项3", content: "选项3" }
    ]
    this.bgColorIsThemeColor = false
    this.hoverBgColorIsThemeColor = true
    this.opacity = 100
    this.bgType = "纯色" //纯色 线性渐变 径向渐变
    this.allBgColor = "rgba(255,255,255,0)" // 全局背景色
    this.bgStartColor = "rgba(23,241,255,1)"
    this.bgEndColor = "rgba(23,116,255,1)"
    this.boxShadowColor = ["rgba(255,255,255,1)"]
    this.boxShadowH = [0]
    this.boxShadowV = [0]
    this.boxShadowBlur = [0]
    this.boxShadowSpread = [0]
    this.allBorderTopLeftRadius = 0
    this.allBorderTopRightRadius = 0
    this.allBorderBottomLeftRadius = 0
    this.allBorderBottomRightRadius = 0
    this.allBorderWidth = 0
    this.allBorderStyle = "solid"
    this.allBorderColor = "#000000"
    this.allBorderIsThemeColor = false
    this.contentHasLimit = true
    this.textLimitLines = 4
    this.padding = 0
    this.paddingTypeFlag = 2
    this.paddingTop = 0
    this.paddingRight = 16
    this.paddingLeft = 16
    this.paddingBottom = 0
    this.iconWidth = 14
    this.iconWidth = 14
    this.updateTimer = 600 // 数据源轮询时间
    this.restDataUrl = "" // 外接数据源地址
    this.marginRight = 16
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
